import { Box, Button, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';
import BusinessIcon from '@mui/icons-material/Business';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import { useFetch } from '../../../hooks/useFecth';
import MetricCard from '../components/MetricCard';
import PeriodButtonGroup from '../components/PeriodButtonGroup';

const chartTooltipSx = {
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
};

const paperSx = {
    p: 3,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: 'none',
};

export default function SalesOverview() {
    const [period, setPeriod] = useState('trimestral');
    const { data: stats } = useFetch('sales/stats', { params: { period } });

    const contratos = stats?.contratos || {};
    const evolution = stats?.evolution || {};

    return (
        <Box>
            <Container maxWidth="xl">
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    gap={2}
                    pb={2}
                >
                    <Box>
                        <Typography variant="h2" gutterBottom>
                            Visão geral
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Evolução de propostas e contratos no período.
                        </Typography>
                    </Box>
                    <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
                        <Button size="small" variant="outlined" component={Link} to="/dashboard/propostas" startIcon={<DescriptionOutlined />}>
                            Propostas
                        </Button>
                        <PeriodButtonGroup value={period} onChange={setPeriod} />
                    </Stack>
                </Stack>

                <Typography variant="h6" fontWeight={600} mb={2}>
                    Propostas e contratos
                </Typography>
                <Grid container spacing={3} mb={4}>
                    <Grid item xs={12} sm={6} md={3}>
                        <MetricCard
                            title="Total no período"
                            value={contratos.total || 0}
                            icon={<BusinessIcon />}
                            subtitle={`${contratos.assinados || 0} assinados`}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <MetricCard title="Pendentes" value={contratos.pendentes || 0} icon={<BusinessIcon />} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <MetricCard title="Sem pagamento" value={contratos.semPagamento || 0} icon={<BusinessIcon />} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <MetricCard title="Concluídos" value={contratos.concluidos || 0} icon={<BusinessIcon />} />
                    </Grid>
                </Grid>

                <Paper sx={{ ...paperSx, mb: 4 }}>
                    <Typography variant="h6" mb={3} fontWeight={600}>
                        Evolução por status
                    </Typography>
                    <ResponsiveContainer width="100%" height={320}>
                        <LineChart data={evolution.contratos || []}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis dataKey="mes" tick={{ fontSize: 12 }} />
                            <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                            <Tooltip contentStyle={chartTooltipSx} />
                            <Legend />
                            <Line type="monotone" dataKey="pendentes" stroke="#FFB547" strokeWidth={2} name="Pendentes" />
                            <Line type="monotone" dataKey="assinados" stroke="#635BFF" strokeWidth={2} name="Assinados" />
                            <Line type="monotone" dataKey="semPagamento" stroke="#FF6B6B" strokeWidth={2} name="Sem pagamento" />
                            <Line type="monotone" dataKey="concluidos" stroke="#00D4AA" strokeWidth={2} name="Concluídos" />
                        </LineChart>
                    </ResponsiveContainer>
                </Paper>
            </Container>
        </Box>
    );
}
